import type { FC, ReactNode } from 'react';
import { Flex, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import styles from './ContactsCard.module.css';

type Props = {
    description: string;
    mail: string;
    icon: ReactNode;
};

export const ContactsCard: FC<Props> = ({ icon, mail, description }) => {
    const { t } = useTranslation();

    return (
        <Flex vertical gap={24} className={styles.contactCard}>
            <Flex gap={24} className={styles.content}>
                <Typography.Heading level={5} color="textSecondary">{t('Contacts_Emails_You')}</Typography.Heading>
                <Typography.Paragraph color="textPrimary">{description}</Typography.Paragraph>
            </Flex>
            <Flex gap={16} justify="end" align="center">
                {icon}
                <a href={`mailto:${mail}`} className={styles.mail}>{mail}</a>
            </Flex>
        </Flex>
    );
};
